import {Field, View, Child, EfeCatalog} from 'commons/models';
import {ActivePathType, ModuleItem} from 'commons/types/Types';
import {useFlowContext} from 'context/onboarding-flow/OnboardingFlow';
import {useMenuContext} from 'context/onboarding-menu/OnboardingMenu';
import {Constants, SnackbarVariants, TypeElement} from 'commons/constants';
import {getCatalogMessage} from 'commons/utils/Messagefunctions';
import {useSnackbar} from 'notistack';
import {useCatalogSearch} from './CatalogHook';
import {notEmpty} from 'commons/utils/Functions';
import {useCatalogContext} from 'context/onboarding-catalog/OnboardingCatalog';

function useFlowUpdate(activePath: ActivePathType) {
    const {flow} = useFlowContext();
    flow.data = activePath.data;
}

async function getCatalogData(field: Field) {
    const {enqueueSnackbar} = useSnackbar();
    const response = await useCatalogSearch(field.catalog);
    if (response) {
        field.catalogValues = [...response];
    } else {
        enqueueSnackbar(getCatalogMessage(field.label), {
            variant: SnackbarVariants.ERROR,
        });
    }
}

function fieldCatalogGetter(fields: Array<Field>): Array<Field> {
    const {catalogs} = useCatalogContext();
    const {enqueueSnackbar} = useSnackbar();
    const customFields: Array<Field> = [];
    for (const field of fields) {
        const customField: Field = {...field, catalogValues: []};
        if (TypeElement.SELECT === customField.typeElement) {
            if (notEmpty(customField.catalog)) {
                const catalog: EfeCatalog | undefined = catalogs.find(
                    (catalog: EfeCatalog) => catalog.name === customField.catalog
                );
                if (catalog) {
                    customField.catalogValues = [...catalog.values];
                } else {
                    getCatalogData(customField);
                }
            } else {
                // enqueueSnackbar(getCatalogMessage(customField.label), {
                //     variant: SnackbarVariants.ERROR,
                // });
                console.log(field, customField);
                console.error(`unknown catalog for ${customField.label}`);
            }
        }
        customFields.push(customField);
    }
    return customFields;
}

function useFlowFieldSearch(): Array<Field> {
    const {flow} = useFlowContext();
    const {layout} = useMenuContext();
    let fields: Array<Field> = [];
    let filteredLayout: Array<View> = layout.views.filter(
        (view: View) => view.viewId === flow.data.viewId
    );
    if (!filteredLayout || !filteredLayout.length) {
        filteredLayout = layout.views;
        for (const view of filteredLayout) {
            const filteredChilds: Array<Child> = view.children.filter(
                (child) => child.viewId === flow.data.viewId
            );
            if (filteredChilds && filteredChilds.length) {
                fields = filteredChilds[0].fields;
            }
        }
    } else {
        fields = filteredLayout[0].fields;
    }

    return fieldCatalogGetter(
        fields.filter((field) => Constants.ATTR_NULL !== field.attrName)
    ).sort((a: Field, b: Field) => (a.idOrder < b.idOrder ? -1 : 1));
}

function useFlowStep(flow: ActivePathType, menu: ModuleItem[]): string {
    let path = '';
    const item: ModuleItem | undefined = menu.find(
        (module) => module.viewId === flow.data.linkedFatherId
    );
    if (item) {
        if (flow.data.linkedChildId && item.items) {
            const child: ModuleItem | undefined = item.items.find(
                (submodule) => submodule.viewId === flow.data.linkedChildId
            );
            if (child) {
                path = `${child.layout}${child.path}`;
            } else {
                console.error('error ubicando siguiente paso, link roto');
            }
        } else {
            path = `${item.layout}${item.path}`;
        }
    } else {
        console.error('error ubicando siguiente paso, link roto');
    }
    return path;
}

export {useFlowUpdate, useFlowFieldSearch, useFlowStep, fieldCatalogGetter};
